export const TYPES = {
    ALL: 'callsAndPuts',
    CALLS: 'calls',
    PUTS: 'puts'
};
